import React, { useState } from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import Calendar from './Calendar';

export default function DateSelector({
    isOpen,
    onClose,
    onDateSelect,
    dateValue,
}) {
    const [dateRange, setDateRange] = useState([null, null]);

    const [activeTab, setActiveTab] = useState('calendar');

    const handleTabChange = tab => {
        setActiveTab(tab);
    };

    if (!isOpen) return null;

    return (
        <div className="absolute mt-2 bg-white rounded-lg shadow-xl z-20 w-full min-w-[800px] right-0 md:right-24 translate-x-1/2 translate-y-0 transform date-selector">

        </div>
    );
}
